import React, { useState, useEffect } from "react";
import { ProposalWithTotals } from "./ProposalWithTotals.jsx";

export function TrendingProposalsWidget({configuration}) {
    const [proposalset, setProposalset] = useState({proposal_set:[], answeredProposals: []});
    const [proposals, setProposals] = useState([]);
    const [name, setName] = useState('')
    const [answeredProposals, setAnsweredProposals] = useState([]);

    useEffect(() => {
      getProposalSet();
    }, []);

    const headers = {
        "Accept-Language": window.location.pathname.split("/")[1],
    }

    const getProposalSet = async () => {
        fetch(`/api/v1/proposals/${configuration.proposalsetId}/get_trending_proposals/`, {headers: headers})
            .then(response => response.json())
            .then(data => {
                setProposalset(data);
                setName(data.name);
                setProposals(data.proposal_set);
                setAnsweredProposals(data.answer_set);
            });
    };

    function markProposalAnswered(proposalId, answer) {
        let answers = [...answeredProposals];
        let item = answers.find(i => i.proposal == proposalId);
        if (item) {
            item.answer = answer;
        } else {
            answers.concat({proposal: proposalId, answer: answer});
        }
        setAnsweredProposals(answers);
    }

    function getAnswer(proposalId) {
        let item = answeredProposals.find(i => i.proposal == proposalId);
        if (item) return item.answer;
        return null;
    }

    let out;
    if (proposals.length > 0) {
        out = (
          <div className="proposalProcessWidget-trendingProposal">
            <h2 className="proposalProcessWidget-trendingProposal_title">
                <i className="icon-tendencia"></i>
                {configuration.translations.title}
            </h2>
            <div id="trending-proposals-widget">
                {proposals.map(proposal =>
                    <ProposalWithTotals
                        key={proposal.pk}
                        name={name}
                        proposal={proposal}
                        configuration={configuration}
                        answer={getAnswer(proposal.pk)}
                        onAnswered={(answer) => markProposalAnswered(proposal.pk, answer)}
                    />
                )}
            </div>
          </div>
        );
    } else {
        out = "";
    }

    return out;
}
